import { Routes, Route } from "react-router-dom";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import Calendar from "./scenes/calendar/calendar";
import LoginPage from "./components/LoginPage.jsx";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "././components/Layout.jsx"
import Order from "./scenes/Order.jsx";
import FirstComponet from "./scenes/team/FirstComponet.jsx";
import SecoundComponet from "./scenes/team/SecoundComponet.jsx";
import HealthComponet from "./scenes/team/HealthComponet.jsx";
import ExclusiveComopent from "./scenes/team/ExclusiveComopent.jsx";
import ArrivalsComponet from "./scenes/team/ArrivalsComponet.jsx";
import Shopbycategory from "./scenes/team/Shopbycategory.jsx";
import ExclusiveStore from "./scenes/team/ExclusiveStore.jsx";
import Insurance from "./scenes/team/Insurance.jsx";
import PersonalComponet from "./scenes/team/PersonalComponet.jsx";
import TopbrandComponet from "./scenes/team/TopbrandComponet.jsx";


function App() {
  return (
    <Routes>
      {/* 🔓 Public */}
      <Route path="/login" element={<LoginPage />} />

      {/* 🔐 Protected */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="team" element={<Team />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="form" element={<Form />} />
        <Route path="bar" element={<Bar />} />
        <Route path="pie" element={<Pie />} />
        <Route path="line" element={<Line />} />
        <Route path="faq" element={<FAQ />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="geography" element={<Geography />} />
        <Route path="order" element={<Order/>} />
         <Route path="firstslider" element={<FirstComponet/>} />
         <Route path="secoundslider" element={<SecoundComponet/>} />
          <Route path="healthslider" element={<HealthComponet/>} />
           <Route path="arrivalslider" element={<ArrivalsComponet/>} />
            <Route path="exclusiveslider" element={<ExclusiveComopent/>} />
             <Route path="shopbycategoryslider" element={<Shopbycategory/>} />
             <Route path="exclusivestoreslider" element={<ExclusiveStore/>} />
             <Route path="insuranceslider" element={<Insurance/>} />
              <Route path="personalslider" element={<PersonalComponet/>} />
              <Route path="topbrandslider" element={<TopbrandComponet/>} />

      </Route>
    </Routes>
  );
}

export default App;
